(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gkikz-collection-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gk-collection-video')) {
    customElements.define('gk-collection-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.video = this.querySelector('video');
        this.button = this.querySelector('button');
        if (!this.video || !this.button) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.manualPause = false;
        this.userStarted = false;
        this.inView = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.button.hidden = false;
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.manualPause = false;
            this.userStarted = true;
            this.playVideo();
          } else {
            this.manualPause = true;
            this.video.pause();
          }
        }, options);
        this.video.addEventListener('play', () => this.updateControl(), options);
        this.video.addEventListener('pause', () => this.updateControl(), options);
        this.video.addEventListener('error', () => { this.button.hidden = true; }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('pageshow', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => { this.userStarted = false; this.syncPlayback(); }, options);
        this.intersection = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        }, { threshold: 0.05 });
        this.intersection.observe(this);
        const header = document.querySelector('.mount-header');
        if (header) {
          const measureHeader = () => this.style.setProperty('--gk-cv-header-height', header.getBoundingClientRect().height + 'px');
          measureHeader();
          this.resize = new ResizeObserver(measureHeader);
          this.resize.observe(header);
        }
        this.updateControl();
      }

      playVideo() {
        const attempt = this.video.play();
        if (attempt) attempt.catch(() => this.updateControl());
      }

      syncPlayback() {
        if (!this.inView || document.hidden || this.manualPause || (this.motion.matches && !this.userStarted)) {
          this.video.pause();
        } else {
          this.playVideo();
        }
      }

      updateControl() {
        const paused = this.video.paused;
        this.button.setAttribute('aria-label', paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
        this.button.querySelector('[data-cv-play]').toggleAttribute('hidden', !paused);
        this.button.querySelector('[data-cv-pause]').toggleAttribute('hidden', paused);
      }

      disconnectedCallback() {
        this.abort?.abort();
        this.intersection?.disconnect();
        this.resize?.disconnect();
        this.video?.pause();
        this.abort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gkikz-vitals-rating"] && !Shopify.designMode) return;
  try {
    if (document.documentElement.dataset.gkikzVitalsRatingScript !== 'ready') {
    document.documentElement.dataset.gkikzVitalsRatingScript = 'ready';

    const renderGkikzVitalsRating = () => {
      const schema = document.querySelector('#vtlsAebReviewsSchemaJson');
      const sourceStars = document.querySelector('.vtl-pr-main-widget--product-page .vtl-pr-totals__stars .vtl-pr-review-stars-snippet__stars');
      if (!schema || !sourceStars) return false;

      try {
        const data = JSON.parse(schema.textContent || '{}');
        const aggregate = data.aggregateRating;
        const rating = Number.parseFloat(aggregate?.ratingValue);
        const count = Number.parseInt(aggregate?.reviewCount, 10);
        if (!Number.isFinite(rating) || !Number.isFinite(count) || count < 1) return false;

        const reviewWidget = document.querySelector('.vtl-pr-main-widget--product-page');
        reviewWidget.id = 'gkikz-vitals-reviews';

        document.querySelectorAll('[data-gkikz-vitals-rating]').forEach(badge => {
          const roundedRating = Math.max(0, Math.min(5, rating));
          const reviewTemplate = count === 1 ? badge.dataset.reviewOne : badge.dataset.reviewOther;
          const reviewLabel = reviewTemplate.replace('999', String(count));
          const ratingLabel = badge.dataset.ratingTemplate.replace('RATING_VALUE', roundedRating.toFixed(2));
          const nativeStars = sourceStars.cloneNode(true);
          nativeStars.style.fontSize = '12px';
          nativeStars.style.height = '12px';
          badge.querySelector('[data-gkikz-vitals-stars]').replaceChildren(nativeStars);
          badge.querySelector('[data-gkikz-vitals-score]').textContent = roundedRating.toFixed(1);
          badge.querySelector('[data-gkikz-vitals-accessible]').textContent = `${ratingLabel}. ${reviewLabel}`;
          badge.hidden = false;

        });

        return true;
      } catch (error) {
        return false;
      }
    };

    if (!renderGkikzVitalsRating()) {
      const observer = new MutationObserver(() => {
        if (renderGkikzVitalsRating()) observer.disconnect();
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }
  } catch(e) { console.error(e); }
})();

})();
